import { render, staticRenderFns } from "./WhatsappBusinessErorr.vue?vue&type=template&id=e28f9478&scoped=true"
import script from "./WhatsappBusinessErorr.vue?vue&type=script&lang=js"
export * from "./WhatsappBusinessErorr.vue?vue&type=script&lang=js"
import style0 from "./WhatsappBusinessErorr.vue?vue&type=style&index=0&id=e28f9478&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28f9478",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VImg})
